import {
	UiComponentBuildContext,
	UiComponentBuilder,
} from "@animech/axiom-ui-builder";

import { Root } from "@definitions";
import { Property, UiNode } from "src/common";
import { CustomNode } from "src/definitions/ui-definitions";

export type CustomNodeType = CustomNode["type"];

export type CustomComponentBuilder<TType extends CustomNodeType> =
	UiComponentBuilder<
		Root,
		CustomNode & {
			type: TType;
		}
	>;

export type CustomComponentBuilderMap = {
	[TType in CustomNodeType]?: CustomComponentBuilder<TType>;
};

type AnyComponentBuilder = UiComponentBuilder<Root, UiNode>;

export type GetNodeVisibility = (
	node: CustomNode,
	activeProperty: Property,
) => boolean;

export class CustomComponentBuilderRouter
	implements UiComponentBuilder<Root, CustomNode>
{
	private _customBuilders: Partial<Record<string, AnyComponentBuilder>>;
	private _getNodeVisibility: GetNodeVisibility;

	constructor(
		customBuilders: CustomComponentBuilderMap,
		getNodeVisibility: GetNodeVisibility,
	) {
		this._customBuilders = customBuilders;
		this._getNodeVisibility = getNodeVisibility;
	}

	public build(node: CustomNode, context: UiComponentBuildContext<Root>) {
		if (!this._getNodeVisibility(node, context.activeProperty)) {
			return undefined;
		}

		const customBuilder = this._customBuilders[node.type];
		return customBuilder ? customBuilder.build(node, context) : undefined;
	}
}
